import React, { useRef } from 'react';
import Compress from 'react-image-file-resizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import styles from './Avatar.module.scss';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';
import env from '../../utils/env';
import loadAvatarValidations from './loadAvatarValidations';

function Avatar() {
  const { viewSize } = useAppContext();
  const { friend, avatar, setAvatar } = useFriendContext();
  const firstNameInitial = friend.firstName?.charAt(0);
  const inputFile = useRef<HTMLInputElement>(null);

  const openFileDialog = () => {
    if (inputFile.current !== null) {
      inputFile.current.click();
    }
  };

  const convertBlobToFile = (blob: Blob, fileName: string): File => new File([blob], fileName);
  const resizeAvatarIfNecessary = (file: File) => {
    const ALLOWED_MAX_SIZE = 512000;
    if (file.size > ALLOWED_MAX_SIZE) {
      Compress.imageFileResizer(
        file, // the file from input
        500, // max width
        500, // max height
        'JPEG', // compress format
        70, // quality
        0, // rotation
        (imageBlob: any) => {
          setAvatar(convertBlobToFile(imageBlob, file.name));
        },
        'blob', // output
      );
    } else {
      setAvatar(file);
    }
  };

  const fileChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (!files || !files[0]) return;
    const imageFile = files[0];
    const img = new Image();
    const imgUrl = URL.createObjectURL(imageFile);

    img.onload = loadAvatarValidations(imageFile, img, () => {
      resizeAvatarIfNecessary(imageFile);
    });

    img.src = imgUrl;
  };

  return (
    <>
      <section className={`${styles.avatar} ${styles[viewSize]}`}>
        {/* TODO: skip the ref logic and style the input to
        replace the fontAwesome camera upload button */}
        <input
          data-testid="avatar"
          ref={inputFile}
          type="file"
          accept="image/jpeg, image/png, image/heic"
          className={styles.fileDialog}
          onChange={fileChangedHandler}
          hidden
        />
        <div className={styles.profileContainer} onClick={openFileDialog} onKeyPress={openFileDialog} role="button" tabIndex={0}>
          <div className={styles.profile} style={{ backgroundImage: avatar?.name ? `url(${URL.createObjectURL(avatar)})` : `url(${env.talkBaseUrl}/letter_avatar_proxy/v4/letter/${firstNameInitial}/68ada1/360.png)` }} />
          <div className={styles.uploadContainer}>
            <FontAwesomeIcon icon={faCamera} size="xs" color="white" className={styles.cameraIcon} />
          </div>
        </div>
        {!avatar?.name
          && (
          <p className={styles.profileInfo} data-testid="avatar-text">
            {friend.firstName}
            , add your profile image so that your friends know who you are.
          </p>
          )}
      </section>
    </>
  );
}

export default Avatar;
